import { useEffect } from 'react'
import { runInAction } from 'mobx'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseConversationUnread } from 'entities/Conversation/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { Inbox } from 'entities/Inbox/model/Inbox'
import { type SidebarStore } from 'widgets/Sidebar/store/sidebarStore'

export const useEventConversationUnread = (sidebarStore: SidebarStore) => {
  const { websocket } = useEntitiesContext()
  const handler = (data: IResponseConversationUnread) => {
    const { inboxesMap } = sidebarStore
    const inbox = inboxesMap.get(data.inbox_id)

    if (inbox instanceof Inbox) {
      runInAction(() => {
        inbox.unread = data.unread
        inbox.unread_messages_count = data.unread_messages_count
        inbox.unread_calls = data.unread_calls
      })
    }
  }

  useEffect(() => websocket.on(WebsocketEvent.ConversationUnread, handler), [])
}
